<template>
  <v-app>
    <v-main>
      <div v-if="application">
        <template v-if="!configureError">
          <treemap />
        </template>
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </div>
    </v-main>
  </v-app>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Treemap from './components/Treemap'

  export default {
    name: 'App',
    components: {
      Treemap,
    },
    computed: {
      ...mapState(['application', 'conceptFilters']),
      ...mapGetters(['config', 'datasetUrl']),
      configureError () {
        if (!this.datasetUrl) return 'Veuillez sélectionner une source de données'
        if (!this.config.aggs || !this.config.aggs.length) return 'Veuillez configurer au moins un groupe'
        return null
      },
    },
    watch: {
      '$route.query': {
        immediate: true,
        async handler () {
          const conceptFilters = {}
          for (const key in this.$route.query) {
            if (key.startsWith('_c_')) {
              conceptFilters[key] = this.$route.query[key]
            }
          }
          this.$store.commit('setAny', { conceptFilters })
          if (!this.configureError) this.$store.dispatch('fetchData')
        },
      },
    },
    mounted () {
    },
    methods: {
      params (p) {
        const params = new URLSearchParams(window.location.search)
        return params.get(p)
      },
    },
  }
</script>
